<template>
  <el-dialog :title="title" class="quickProceDialog" :visible.sync="dialogVisible" width="80%"
    @close="dialogCloseHandle">
    <div class="operatingFloor">
      <div class="totalAmount">{{ $t('eventList.Taoa') }}：<span>{{ totalCost }}</span></div>
      <el-tooltip effect="dark" :content="tips" :disabled="echoData.allowRecallEdit" placement="bottom-start">
        <div class="btn">
          <el-button type="primary" @click="recallBtn" :disabled="!echoData.allowRecallEdit">{{ $t('eventList.Rc') }}
          </el-button>
        </div>
      </el-tooltip>
    </div>
    <commonTable ref="quickProceTable" />
  </el-dialog>
</template>

<script>
import commonTable from '@/components/commonTable';
import { TableRow, TableColumns } from '@/utils/tableOptions.js';
import { activistyCostAttribution, activityQuery, activityQueryDetails } from '@/views/activitieList/service';
import { newApplicationFormApi } from '@/views/newApplicationForm/service';

export default {
  data() {
    return {
      rules: {
        directors: [
          { required: true, message: this.$t('eventList.Psaem'), trigger: 'blur' }
        ],
        reason: [
          { required: true, message: this.$t('eventList.Peac'), trigger: 'blur' }
        ]
      },
      dialogVisible: false,
      echoData: {},
      tableData: [],
      totalCost: 0,
      formData: {},
      directorsShow: true,
      directorsLoading: false,
      directorsList: [],
      tips: this.$t('eventList.Yanaafte'),
      lang: localStorage.getItem('lang') || 'zh-CN'
    };
  },
  components: {
    commonTable
  },
  props: {
    title: {
      type: String,
      default: '撤销'
    },
    quickProceDialogVisible: {
      type: Boolean,
      default: false
    },
    activityCode: {
      type: String,
      default: ''
    },
    usePage: {
      type: String,
      default: ''
    },
    approveStatusCode: {
      type: Number,
      default: null
    }
  },
  watch: {
    quickProceDialogVisible(val) {
      if (val) {
        this.loadTable();
        this.getBasicInfoData();
      } else {
        this.echoData = {};
        this.tableData = [];
      }
      this.dialogVisible = val;
    }
  },
  methods: {
    remoteMethod(query) {
      if (query !== '') {
        this.directorsLoading = true;
        newApplicationFormApi.getChargeman(query).then(res => {
          if (res.status === '200') {
            if (res.data && res.data.length > 0) {
              this.directorsList = res.data;
            } else {
              this.directorsList = [];
            }
          }
          this.directorsLoading = false;
        });
      } else {
        this.directorsList = [];
      }
    },
    recallBtn() {
      this.$confirm(this.$t('eventList.OKRMta'), this.$t('general.Hint'), {
        confirmButtonText: this.$t('btn.OK'),
        cancelButtonText: this.$t('btn.Cancel'),
        type: 'warning'
      }).then(() => {
        let requestUrl = activityQuery.recallModification;

        // 如果是报备就走报备召回接口
        if (this.echoData.marketActivity.submitType === 'report_submit') {
          requestUrl = activityQuery.reportRecall;
        }

        this.$store.commit('setSubPageLoading', true);
        requestUrl(this.echoData.marketActivity.activityCode).then(res => {
          if (res.status === '200') {
            this.$router.push('/drafts');
            this.$message.success(this.$t('general.OperSucc'));
          }
          this.dialogCloseHandle();
          this.$store.commit('setSubPageLoading', false);
        });
      }).catch(() => {
        this.$store.commit('setSubPageLoading', false);
      });
    },
    agreeRejectBtn(val) {
      let selected;
      if (this.$refs.activistyCostAttribution) {
        selected = this.$refs.activistyCostAttribution.getCheckedItem();
      }
      if (this.$refs.activistyCostAttribution && selected.length > 0) {
        activityQueryDetails.getProcessHistory(selected[0].id).then(res => {
          if (res.status === '200') {
            let { mactFlowLogList } = res.data;
            this.approved = mactFlowLogList[mactFlowLogList.length - 1].assigneeName;
            this.agreeDialogTitle = val ? this.$t('btn.Agree') : this.$t('btn.Rejected');
            this.agreeRejectFlage = val;
            this.agreeDialogVisible = true;
          }
        });
      } else {
        this.activeName = 'activistyCostAttribution';
        this.$message.warning(this.$t('eventList.PsaeiuFA'));
      }
    },
    revokeBtn(row) {
      const pathList = ['regionReportList', 'industryReportList'];
      let info = '';
      if (row.reportType && this.$route.path === '/activityQuery') {
        info = this.$t('eventList.bbzsqcxtsy');
      } else {
        info = pathList.includes(this.usePage) && this.approveStatusCode === 100 ? this.$t('eventList.qdcxgfym') : this.$t('eventList.Aysywtctf');
      }
      this.$confirm(info, this.$t('general.Hint'), {
        confirmButtonText: this.$t('btn.OK'),
        cancelButtonText: this.$t('btn.Cancel'),
        type: 'warning'
      }).then(() => {
        let requestUrl = activistyCostAttribution.activistyCostRevoke;
        // 判断是否是报备：如果是则调用报备撤销费用接口
        if (this.echoData.marketActivity.submitType === 'report_submit') {
          requestUrl = activistyCostAttribution.reportRevoke;
        }
        this.$store.commit('setSubPageLoading', true);
        requestUrl(row.id).then(res => {
          this.$store.commit('setSubPageLoading', false);
          if (res.status === '200') {
            this.getBasicInfoData();
            this.$message.success(this.$t('general.OperSucc'));
          } else if (res.status === '800150') {
              const { expCode, activityCode } = row;
              const { sysUser } = this.$store.state.userInfo;
              const eventcode = activityCode;
              const expensecode = expCode;
              const rjPercode = sysUser.userId;
              const params = {
                method: 'order_cancelpage',
                reqData: `<?xml version="1.0" encoding="utf-8"?><body><eventcode>${eventcode}</eventcode><expensecode>${expensecode}</expensecode><rj_percode>${rjPercode}</rj_percode><lang>${this.lang === 'zh-CN' ? 'zh_cn' : 'en_us'}</lang></body>`,
                lang: this.lang === 'zh-CN' ? 'zh_cn' : 'en_us'
              };
              this.$confirm(this.$t('newApp.Attribute.RevokeInfo'), this.$t('general.Hint'), {
                confirmButtonText: this.$t('approvalCenter.ToDealWith'),
                cancelButtonText: this.$t('btn.Cancel'),
                type: ''
              }).then(() => {
                newApplicationFormApi.getGiftUrl(params).then(res => {
                  if (res.status === '200') {
                    window.open(res.data);
                  }
                });
              }).catch(() => {

              });
          }
        });
      }).catch(() => {

      });
    },
    dialogCloseHandle() {
      this.$emit('dialogCloseHandle');
    },
    isShowVerify(data) {
      return data.some(item => {
        return item.allowCancel;
      });
    },
    isShowProductLine(data) {
      return data.some(item => {
        return item.productLine;
      });
    },
    loadTable() {
      let tableRow = new TableRow();
      // tableRow.push(
      //   new TableColumns()
      //     ._width('4%')
      //     ._others('checkbox')
      // );
      tableRow.push(
        new TableColumns()
          ._width('6%')
          ._title(this.$t('newApp.BasicInfo.Applicant'))
          ._data('salerName')
      );
      tableRow.push(
        new TableColumns()
          ._width('10%')
          ._title(this.$t('newApp.BasicInfo.fs'))
          ._data('financialSystemName')
      );
      tableRow.push(
        new TableColumns()
          ._width('10%')
          ._title(this.$t('newApp.BasicInfo.toc'))
          ._data('currencyType')
      );
      tableRow.push(
        new TableColumns()
          ._width('12%')
          ._title(this.$t('newApp.Attribute.cad'))
          ._data('deptName')
      );
      tableRow.push(
        new TableColumns()
          ._width('10%')
          ._title(this.$t('newApp.Attribute.toe'))
          ._data('expenseType')
      );
      tableRow.push(
        new TableColumns()
          ._width('8%')
          ._title(this.$t('newApp.Attribute.ms'))
          ._data('subMarket')
      );
      if (this.isShowProductLine(this.tableData)) {
        tableRow.push(
          new TableColumns()
            ._width('6%')
            ._title(this.$t('newApp.Attribute.pl'))
            ._data('productLine')
        );
      }
      tableRow.push(
        new TableColumns()
          ._width('130')
          ._title(this.$t('newApp.Attribute.bbje'))
          ._data('reportApplyAmount')
      );
      // tableRow.push(
      //   new TableColumns()
      //     ._width('8%')
      //     ._title(this.$t('eventList.FeeAA'))
      //     ._align('right')
      //     ._data('applyAmount')
      // );
      // tableRow.push(
      //   new TableColumns()
      //     ._width('6%')
      //     ._title(this.$t('newApp.Attribute.ac'))
      //     ._align('right')
      //     ._data('activityCost')
      //     ._cellType('customDom')
      //     ._cellData({
      //       formater: ({ row, column }) => {
      //         return (
      //           <span>
      //             {row[column.property] ? row[column.property] : '-'}
      //           </span>
      //         );
      //       }
      //     })
      // );
      // tableRow.push(
      //   new TableColumns()
      //     ._width('8%')
      //     ._title(this.$t('newApp.Attribute.coam'))
      //     ._align('right')
      //     ._data('advertisingCost')
      //     ._cellType('customDom')
      //     ._cellData({
      //       formater: ({ row, column }) => {
      //         return (
      //           <span>
      //             {row[column.property] || '-'}
      //           </span>
      //         );
      //       }
      //     })
      // );
      tableRow.push(
        new TableColumns()
          ._width('9%')
          ._title(this.$t('general.Remarks'))
          ._data('note')
      );
      tableRow.push(
        new TableColumns()
          ._title(this.$t('general.Status'))
          ._width('8%')
          ._data('status')
      );
      if (this.isShowVerify(this.tableData) && this.echoData.marketActivity.applyUserId === this.$store.state.userInfo.sysUser.userId) {
        tableRow.push(
          new TableColumns()
            ._title(this.$t('general.Operation'))
            ._width('12%')
            ._cellType('customDom')
            ._cellData({
              formater: ({ row, column }) => {
                return (
                  <div>
                    {
                      row.allowCancel ? (
                        <el-button type="text" onClick={() => { this.revokeBtn(row); }}>{this.$t('btn.Revoke')}</el-button>
                      ) : null
                    }
                  </div>
                );
              }
            })
        );
      }
      let column = tableRow._cols();
      this.$nextTick(() => {
        this.$refs.quickProceTable.setColumn(column, {
          page: false
        });
        this.$refs.quickProceTable.loadStaticTable(this.tableData);
      });
    },
    getBasicInfoData() {
      this.$nextTick(() => {
        this.$refs.quickProceTable.loading = true;
      });
      const pathList = ['/regionReportList', '/industryReportList'];
      const requestUrl = pathList.includes(this.$route.path) ? activityQueryDetails.getReportBasicInfoData : activityQueryDetails.getBasicInfoData;
      requestUrl(this.activityCode).then(res => {
        if (res.status === '200') {
          this.echoData = res.data;
          this.tableData = this.echoData.mactExpenseBelongVOList.map(item => {
            return {
              ...item.mactExpenseBelong,
              advertiseExpenseDetails: item.advertiseExpenseDetails,
              activityExpenseDetails: item.activityExpenseDetails,
              salerName: item.mactExpenseBelong.applyUserName,
              taskId: item.mactFlowTask ? item.mactFlowTask.taskId : null,
              allowBorrow: item.allowBorrow,
              allowCancel: item.allowCancel,
              allowVerification: item.allowVerification,
              borrowingMoneyTotal: item.borrowingMoneyTotal,
              reportType: this.echoData.marketActivity.reportType,
              status: item.status
            };
          });
          this.totalCost = this.echoData.marketActivity.totalCost;
          if (this.echoData.marketActivity.applyUserId !== this.$store.state.userInfo.sysUser.userId) {
            this.tips = this.$t('eventList.Yanaafte');
          } else {
            this.tips = this.$t('eventList.Tsosro');
          }
          this.$refs.quickProceTable.loading = false;
          this.loadTable();
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/style/common';

.quickProceDialog {
  ::v-deep.el-dialog {
    margin-top: 6vh !important;
  }

  .formWrap {
    width: 100%;
    border: 1px solid #EBEEF5;
    margin-top: 20px;

    >.el-form {
      max-width: 1000px;
      //margin: 0 auto;
      padding: 20px 20px 0;
    }
  }

  .operatingFloor {
    @extend .clear;

    .totalAmount {
      float: left;
    }

    .btn {
      float: right;
    }
  }

}
</style>
